export const signatureStyles = `
  .signature-main .up.a { margin: 0 -10px 0 -7px; }
  .signature-main .up.b { margin: 0 -5px 0 -13px; }
  .signature-main .up.c { margin: 0 -5px 0 -6px; }
  .signature-main .up.d { margin: 0 -6px 0 -6px; }
  .signature-main .up.e { margin: 0 -10px 0 -8px; }
  .signature-main .up.f { margin: 0 -13px 0 -5px; }
  .signature-main .up.g { margin: 0 0px 0 -6px; }
  .signature-main .up.h { margin: 0 -8px 0 -6px; }
  .signature-main .up.i { margin: 0 -25px 0 -16px; }
  .signature-main .up.j { margin: 0 -24px 0 -6px; }
  .signature-main .up.k { margin: 0 -23px 0 -3px; }
  .signature-main .up.l { margin: 0 -7px 0 -5px; }
  .signature-main .up.m { margin: 0 -7px 0 -10px; }
  .signature-main .up.n { margin: 0 -4px 0 -10px; }
  .signature-main .up.o { margin: 0 -1px 0 -1px; }
  .signature-main .up.p { margin: 0 -12px 0 -3px; }
  .signature-main .up.q { margin: 0 -3px 0 -3px; }
  .signature-main .up.r { margin: 0 -8px 0 -4px; }
  .signature-main .up.s { margin: 0 -14px 0 -2px; }
  .signature-main .up.t { margin: 0 -29px 0 -17px; }
  .signature-main .up.u { margin: 0 -10px 0 -1px; }
  .signature-main .up.v { margin: 0 -15px 0 -6px; }
  .signature-main .up.w { margin: 0 -8px 0 -6px; }
  .signature-main .up.x { margin: 0 -11px 0 -13px; }
  .signature-main .up.y { margin: 0 -12px 0 2px; }
  .signature-main .up.z { margin: 0 -9px 0 -8px; }
  .signature-main .lo.a { margin: 0 -4px 0 0; }
  .signature-main .lo.b { margin: 0 -6px 0 -1.5px; }
  .signature-main .lo.c { margin: 0 -4px 0 0; }
  .signature-main .lo.d { margin: 0 -11.3px 0 0; }
  .signature-main .lo.e { margin: 0 -4px 0 0; }
  .signature-main .lo.f { margin: 0 -6px 0 -6px; }
  .signature-main .lo.g { margin: 0 -4px 0 -10px; }
  .signature-main .lo.h { margin: 0 -4px 0 -1px; }
  .signature-main .lo.i { margin: 0 -3.5px 0 0; }
  .signature-main .lo.j { margin: 0 -5px 0 -14px; }
  .signature-main .lo.k { margin: 0 -6.5px 0 0; }
  .signature-main .lo.l { margin: 0 -12px 0 -4px; }
  .signature-main .lo.m { margin: 0 -5px 0 0; }
  .signature-main .lo.n { margin: 0 -5px 0 0; }
  .signature-main .lo.o { margin: 0 -2.5px 0 0; }
  .signature-main .lo.p { margin: 0 -2.5px 0 -10px; }
  .signature-main .lo.q { margin: 0 -2px 0 -6px; }
  .signature-main .lo.r { margin: 0 -3px 0 -1px; }
  .signature-main .lo.s { margin: 0 -4px 0 -4px; }
  .signature-main .lo.t { margin: 0 -12.5px 0 -3.5px; }
  .signature-main .lo.u { margin: 0 -4.5px 0 0; }
  .signature-main .lo.v { margin: 0 -4.5px 0 0; }
  .signature-main .lo.w { margin: 0 -4px 0 0; }
  .signature-main .lo.x { margin: 0 -4px 0 0; }
  .signature-main .lo.y { margin: 0 -4px 0 -9px; }
  .signature-main .lo.z { margin: 0 -4px 0 -10px; }
`;

